import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import CallToAction from '@micromag/element-call-to-action';

var styles = {};

var propTypes = {
  callToAction: PropTypes$1.callToAction,
  className: PropTypes.string
};
var defaultProps = {
  callToAction: null,
  className: null
};
function Footer(_ref) {
  var callToAction = _ref.callToAction,
    className = _ref.className;
  if (callToAction === null) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(CallToAction, callToAction));
}
Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export { Footer as default };
